export interface OpenServiceChargePaymentsParams {
    paymentIds: readonly string[];
    selectableIds: readonly string[];
    isWeb: boolean;
    openSingleOnWeb: (paymentId: string) => void;
    openSingleNative: (paymentId: string) => void;
    openSelectedList: (selectedPaymentIds: readonly string[]) => void;
    openEmptyList: () => void;
}

/** Route a service-charge summary card without nesting that logic in the screen. */
export function openServiceChargePayments({
    paymentIds,
    selectableIds,
    isWeb,
    openSingleOnWeb,
    openSingleNative,
    openSelectedList,
    openEmptyList,
}: Readonly<OpenServiceChargePaymentsParams>): void {
    if (paymentIds.length === 1) {
        const paymentId = paymentIds[0];
        if (!paymentId) {
            openEmptyList();
            return;
        }
        if (isWeb) {
            openSingleOnWeb(paymentId);
            return;
        }
        openSingleNative(paymentId);
        return;
    }

    if (paymentIds.length > 1 && selectableIds.length > 0) {
        openSelectedList(selectableIds);
        return;
    }

    openEmptyList();
}
